export const AutoInvoiceNumber = async (token, userId) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/get-invoice-number`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};

export const MemberDuePayment = async (token, userId, FormData) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    member_id: FormData.member_id,
    payment_id: FormData.payment_id,
    paying_amount: FormData.payingAmount,
    discount: FormData.discount || 0,
    mode_of_payment: FormData.modeofpayment,
    date_of_payment: FormData.dateofpayment,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/member-due-payment`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};



export const MembeRenwalPackage = async (token, userId, conversation_id,FormData) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    member_id: conversation_id,
    package_id: FormData.package_id,
    offer:FormData.offer,
    payble_amount: FormData.payble_amount,
    total_payble_amount: FormData.total_payble_amount,
    paying_amount: FormData.paying_amount,
    mode_of_payment: FormData.mode_of_payment,
    date_of_payment: FormData.date_of_payment,
    start_date: FormData.start_date,
    admission_value_id: FormData.membership,
    admission_value: FormData.membershipvalue,
    // Yearly membership as its own separate payment (own payble/offer/paying/due) —
    // when present, the backend creates an independent YearlyPackage record instead
    // of bundling it into the main package's paying_amount.
    yearly_payble_amount: FormData.yearly_payble_amount,
    yearly_paying_amount: FormData.yearly_paying_amount,
    yearly_offer: FormData.yearly_offer,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/renew-package`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};
export const MembeRepeatPackage = async (userToken, userId, conversation_id, packageIdrepeat, repeatModeOfPayment, repeatOffer,admission_value_id,admission_value) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);

  const raw = JSON.stringify({
    user_id: userId,
    member_id: conversation_id,
    package_id: packageIdrepeat,
    mode_of_payment: repeatModeOfPayment,
    offer: repeatOffer,
    admission_value_id:admission_value_id,
    admission_value:admission_value
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/add/same-package`,
      requestOptions
    );

    // Check if the response is ok (status code 200-299)
    if (!response.ok) {
      // Log the response for debugging
      const errorText = await response.text();  // Get the raw response text
      console.error("Response error:", errorText);
      throw new Error(`HTTP error! Status: ${response.status}, Response: ${errorText}`);
    }

    // Attempt to parse the response as JSON
    const result = await response.json();
    return result;
  } catch (error) {
    // Log the full error message for debugging
    console.error("Fetch error:", error);
    throw new Error("Failed to retrieve package: " + error.message);
  }
};


export const TrainerChange = async (token, id, trainerID) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    id: id,
    trainer_id: trainerID,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/change-trainer-name`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};


